require.register("ffss/component/row/CompetitionSearch", function(exports, require, module){
  $0
  
});

